<app-interview-sidebar>
  <div class="full-width copilot-page vertical">
    <div class="page-header">
      <div class="horizontal seperate bottom">
        <div class="page-title margin-top vertical">Mock Interview</div>

        <!-- <button nz-button nzType="primary" nzSize="default" (click)="onNewInterviewClick()">
          <span nz-icon style="font-size: 16px" class="material-icons-outlined">add</span>
          Add Interview
        </button> -->
      </div>
    </div>

    <div class="basic-block">
      <h2>New version beta testing, available by invite only.</h2>

      <youtube-player class="youtube-player" [videoId]="'Fn_oqGJiJ48'" suggestedQuality="highres" [width]="'80%'">
      </youtube-player>
    </div>
  </div>
</app-interview-sidebar>
